import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { useEffect } from 'react';

export default function SouthendPage() {
  useEffect(() => {
    document.title = 'Southend-on-Sea Bollard Installation | Security Bollards Essex';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional bollard installation in Southend-on-Sea, Essex. Coastal-grade telescopic, fold-down & electric bollards. Call +44 7834 858178');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <section className="relative bg-gradient-to-br from-black via-gray-900 to-black py-24 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <div className="inline-flex items-center space-x-2 bg-yellow-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <i className="ri-map-pin-line text-yellow-500"></i>
                <span className="text-yellow-500 font-semibold">Southend-on-Sea, Essex</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
                Bollard Installation in <span className="text-yellow-500">Southend-on-Sea</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Expert coastal bollard installation services for Southend-on-Sea. Serving 295,000+ residents 
                with marine-grade security bollards designed to withstand coastal conditions.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-phone-line text-xl"></i>
                  <span>Call +44 7834 858178</span>
                </a>
                <a href="/quote" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-file-list-line text-xl"></i>
                  <span>Get Free Quote</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Coastal Bollard Solutions for <span className="text-yellow-500">Southend</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Specialized bollard installation for coastal properties. Our marine-grade bollards are 
                designed to withstand salt air and harsh weather conditions.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-arrow-up-down-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Telescopic Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Corrosion-resistant telescopic bollards perfect for Southend coastal properties. 
                  Built to last in marine environments.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Marine-grade materials</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Salt-resistant coating</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Coastal durability</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-arrow-down-circle-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Fold Down Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Heavy-duty fold-down bollards for Southend businesses and seafront properties. 
                  Weather-resistant and reliable.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Weatherproof construction</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Secure locking system</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Low maintenance</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-flashlight-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Electric Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Automated bollards with coastal protection for Southend commercial properties. 
                  Remote operation with marine-grade components.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Remote control access</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Coastal-grade sealing</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>LED lighting options</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Why Choose Us for <span className="text-yellow-500">Southend</span>?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-ship-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Coastal Specialists</h3>
                <p className="text-gray-600">
                  Expert knowledge of coastal property requirements and marine-grade installations
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Fast Service</h3>
                <p className="text-gray-600">
                  Quick response across Southend with efficient installation scheduling
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Quality Materials</h3>
                <p className="text-gray-600">
                  Marine-grade bollards with comprehensive warranty coverage
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Ongoing Support</h3>
                <p className="text-gray-600">
                  Maintenance services available throughout Southend
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Southend Areas We <span className="text-yellow-500">Serve</span>
              </h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {[
                'Southend Town Centre',
                'Leigh-on-Sea',
                'Westcliff-on-Sea',
                'Thorpe Bay',
                'Shoeburyness',
                'Prittlewell',
                'Eastwood',
                'Rochford'
              ].map((area, index) => (
                <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-yellow-500 hover:bg-yellow-500/5 transition-all cursor-pointer">
                  <i className="ri-map-pin-line text-yellow-500 text-xl mb-2"></i>
                  <p className="font-semibold text-gray-800">{area}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-br from-black to-gray-900">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h2 className="text-4xl md:text-5xl font-black mb-6">
                Protect Your <span className="text-yellow-500">Southend</span> Property
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                Get a free quote for coastal-grade bollard installation in Southend-on-Sea. 
                Our expert team provides durable solutions for seaside properties.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-phone-line text-xl"></i>
                  <span>Call +44 7834 858178</span>
                </a>
                <a href="/quote" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-file-list-line text-xl"></i>
                  <span>Request Free Quote</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}